require("../../base/js/app.js");
require('bootstrap-datepicker');


// Coupon copy code, only works on https
const couponInputFields = document.querySelectorAll('.js-coupon__input');
const couponCopyBtns = document.querySelectorAll('.js-coupon__copy');

let lastLogTime = 0;
const logTimeout = 20000; // 20 seconds

function canLog() {
    const currentTime = Date.now();
    if (currentTime - lastLogTime > logTimeout) {
        lastLogTime = currentTime;
        return true;
    }
    return false;
}

if (couponInputFields.length > 0) {
    couponInputFields.forEach((input) => {
        input.addEventListener('copy', (e) => {
            const articleId = input.closest('.js-coupon').dataset.articleId;
            const memberId = input.closest('.js-coupon').dataset.memberId;
            const hasRefreshButton = !!document.querySelector('.code-refresh');
            const code = input.value;
            if (canLog() && !hasRefreshButton) {
                saveLog(articleId, memberId, code);
            }
        });
    });
}

if (couponCopyBtns.length > 0) {
    couponCopyBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const codeText = btn.closest('.js-coupon').querySelector('.js-coupon__input');
            const articleId = btn.closest('.js-coupon').dataset.articleId;
            const memberId = btn.closest('.js-coupon').dataset.memberId;
            const hasRefreshButton = !!document.querySelector('.code-refresh');
            codeText.select();
            codeText.setSelectionRange(0, 99999);
            try {
                document.execCommand('copy');
                if (canLog() && !hasRefreshButton) {
                    saveLog(articleId, memberId, codeText.value);
                }
            } catch (error) {
                console.error('Fallback: Oops, unable to copy', error);
            }
        });
    });
}

function saveLog(articleId, memberId, code) {
    fetch('/log-article-code', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
            article_id: articleId,
            member_id: memberId,
            code: code,
        })
    }).then(response => response.json())
        .then(data => {
            if (data.success) {
                console.log('Log saved successfully');
            } else {
                console.error('Failed to save log');
            }
        }).catch(error => {
        console.error('Error:', error);
    });
}

// Get all elements with the class "js-modal"
const modalElements = document.querySelectorAll('.js-modal');

// Get the modal container
const modalContainer = document.getElementById('jsLevelModal');

// Get the title and content elements in the modal
const modalTitle = document.getElementById('modalTitle');
const modalContent = document.getElementById('modalContent');

// Function to open the modal with animation
function openModal(title, content) {
    if (modalTitle && modalContent && modalContainer) {
        modalTitle.textContent = title;
        modalContent.innerHTML = content;

        // Add the "open" class
        modalContainer.classList.add('open');
    }
}

// Function to close the modal with animation
function closeModal() {
    if (modalContainer) {
        // Remove the "open" class
        modalContainer.classList.remove('open');
    }
}

// Add click event listeners to all elements with class "js-modal"
if (modalElements) {
    modalElements.forEach((element) => {
        element.addEventListener('click', () => {
            const title = element.getAttribute('data-title');
            const content = element.getAttribute('data-content');
            openModal(title, content);
        });
    });
}

// Add click event listener to close button
const closeButton = document.querySelector('.c-modal__close');
if (closeButton) {
    closeButton.addEventListener('click', closeModal);
}

// Add click event listener to modal backdrop to close modal
const modalBackdrop = document.querySelector('.c-modal__backdrop');
if (modalBackdrop) {
    modalBackdrop.addEventListener('click', closeModal);
}

// Add event listener for the Escape key to close modal
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        closeModal();
    }
});

let couponStorage = localStorage.getItem("vgz-questions");

var couponModal = document.createElement("div");

couponModal.innerHTML = `<h1 style="font-size:24px!important;margin-bottom:16px;">Hee daar, voordeelpakker!</h1><p style="margin-bottom:32px;">Wat vind jij van de Lebara Voordeelclub?</p><p><div style="display:flex; flex-direction: column; justify-content: center; align-items: center;flex-wrap: wrap;"><a href=\"https://survey.alchemer.eu/s3/90706795/Lebara-Voordeelclub\" class="btn btn-primary" style="display:block;width:100%;" target="_blank">Deel je mening</a> </p> <a class="c-btn c-btn--clear" style="color:#fd0063 !important;font-size:18px;" href=\"#\" onclick=\"document.getElementById('sg-popup').style.display = 'none';return false;\">Liever niet</a><a href=\"#\" onclick=\"document.getElementById('sg-popup').style.display = 'none';return false;\" style="position:absolute;top:10px;right:16px;text-decoration:none;color:#000 !important;font-size:18px;font-weight:400;"><i class="fa-regular fa-xmark"></i></a></div>`;
couponModal.id = "sg-popup";
let couponModalButtons = couponModal.querySelectorAll("a");
couponModalButtons.forEach(function (couponModalButton) {
    couponModalButton.addEventListener("click", function () {
        localStorage.setItem("vgz-questions", "true");
        couponModal.style.display = "none";
    });
});

window.setTimeout(function () {
    if (couponStorage === null) {
        document.body.appendChild(couponModal);
    }
}, 30000)




// WEBPACK FOOTER //
// ./resources/assets/default_benefit/js/app.js